// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2uQMy","content":"ManualTimeModal_content__353x2"};